module.exports = __webpack_public_path__ + "img/ic_main_menu_as.ee9fdc90.png";